// @flow
import { styled } from 'mz-ui-kit'

const TYPE_TO_COLOR = {
  help: (palette) => palette('text').lighten(50),
  info: (palette) => palette('text'),
  warning: (palette) => palette('yellow'),
  error: (palette) => palette('red'),
  success: (palette) => palette('green'),
}

export const HelpContainer = styled<{
  $type: 'help' | 'info' | 'warning' | 'error' | 'success',
}>('div', ({ $palette, $type }) => {
  const textColorGen = TYPE_TO_COLOR[$type] || TYPE_TO_COLOR.help
  return {
    marginTop: '5px',
    color: `${textColorGen($palette)}`,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'flex-start',
  }
})

export const IconWrapper = styled('div', {
  marginRight: '5px',
  marginTop: '1px',
})
